export default class StoreRef<T> {
   sp
   ref?: T

   constructor(sp?: { onSet?: () => any }) {
      this.sp = sp
   }

   get store() {
      if (!this.ref) {
         throw Error("`store` should be defined here. Check the error stack for more info")
      }
      return this.ref
   }

   setStore = (store: T) => {
      this.ref = store
      this.sp?.onSet?.()
   }
}